// extracted by mini-css-extract-plugin
export var container = "section-top-module--container--W1Eg5";
export var contents = "section-top-module--contents--12j55";
export var background = "section-top-module--background--PKxdz";
export var img_logo = "section-top-module--img_logo--ccWXv";
export var phrase = "section-top-module--phrase--rFrma";
export var catchphrase = "section-top-module--catchphrase--2F5ra";
export var description = "section-top-module--description--ztTUK";
export var buttons = "section-top-module--buttons--n0APV";